function setCookie(name, value) {
  document.cookie = name + "=" + (value || "") + "; expires=" + value + "; path=/";
}

function getCookie(name) {
  let nameEQ = name + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

function addMinutes(date, minutes) {
  date.setMinutes(date.getMinutes() + minutes);
  return date;
}

function getMinutes(date1, date2) {
  return Math.abs((date1.getTime() - date2.getTime()) / 60000);
}

function initOfferTimer2(
  cookieName,
  offerMinsToAdd,
  daysId,
  hoursId,
  minsId,
  secondsId
) {
  // 1. Get cookie if it exists
  let cookie = getCookie(cookieName);
  let now = new Date();
  let newExpiry = addMinutes(now, offerMinsToAdd);

  // Set default
  let countdownDate = new Date()

  // 2. Check if cookie exists
  if (cookie) {
    // 3. Get cookie stored date
    let storedDate = new Date(cookie);
    let storedMins = getMinutes(storedDate, now);
    // 4. Check if cookie(in mins) has changed from (offerMinsToAdd) time.
    if (storedMins != offerMinsToAdd) {
      // 5. Set a new cookie with updated mins.
      setCookie(cookieName, newExpiry.toUTCString());
      countdownDate = newExpiry
    } else {
      countdownDate = storedDate
    }
  }
  // 2. Set cookie
  else {
    setCookie(cookieName, newExpiry.toUTCString());
    countdownDate = newExpiry
  }
  let timerId;

  function updateCountdown() {
    const timeLeft = countdownDate.getTime() - new Date().getTime();
    const days = Math.max(0, Math.floor(timeLeft / (1000 * 60 * 60 * 24)));
    const hours = Math.max(0, Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
    const minutes = Math.max(0, Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)));
    const seconds = Math.max(0, Math.floor((timeLeft % (1000 * 60)) / 1000));

    // Check if cookie timer has past
    if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
      // Remove element
      document.getElementById(daysId).parentElement.style.opacity = 0
      document.getElementById(hoursId).parentElement.style.opacity = 0
      document.getElementById(minsId).parentElement.style.opacity = 0
      document.getElementById(secondsId).parentElement.style.opacity = 0
      eraseCookie(cookieName);

      clearInterval(timerId)
      return;
    }

    let formatSettings = {
      minimumIntegerDigits: 2,
      useGrouping: false,
    };

    document.getElementById(daysId).textContent = days.toLocaleString("en-US", formatSettings);
    document.getElementById(hoursId).textContent = hours.toLocaleString("en-US", formatSettings);
    document.getElementById(minsId).textContent = minutes.toLocaleString("en-US", formatSettings);
    document.getElementById(secondsId).textContent = seconds.toLocaleString("en-US", formatSettings);
  }
  updateCountdown();
  timerId = setInterval(updateCountdown, 1000);
}

function initOfferTimer(
  cookieName,
  offerMinsToAdd,
  daysId,
  hoursId,
  minsId,
  secondsId
) {
  initOfferTimer2(cookieName, offerMinsToAdd, daysId, hoursId, minsId, secondsId)
  return;
}
